<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1 class="m-0">Configuración de Bancos</h1>
                </div><!-- /.col -->
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">
                                Home
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">Bancos</li>
                    </ol>
                </div><!-- /.col -->
            </div><!-- /.row -->
        </div><!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="d-flex justify-content-between">
                                <h3 class="card-title">Lista de Bancos</h3>
                                <PrimaryButton class="btn btn-primary" data-toggle="modal" data-target="#modal-lg"
                                    @click="modalContent = 1; editing = false">
                                    {{ $getLocaleMessage('buttons', 'addNewRecord') }}
                                </PrimaryButton>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="d-flex">
                                <input type="text" class="form-control" placeholder="Buscar Bancos..."
                                    v-model="searchString" />
                            </div>
                            <!-- /.d-flex -->

                            <div class="position-relative col-sm-12">
                                <BanksTable :list="filteredBanks" :itemsPerPage="itemsPerPage"
                                    :currentPage="currentPage"
                                    @editBank="setSelectedRecord($event); modalContent = 2; editing = true">
                                </BanksTable>
                                <Pagination :list="filteredBanks" :itemsPerPage="itemsPerPage"
                                    :currentPage="currentPage" @currentPage="currentPage = $event"></Pagination>

                                <Modal>
                                    <AddBankForm v-if="modalContent == 1 && editing == false" @closeModal="modalStatus"
                                        @changeModalContent="modalContent = $event">
                                    </AddBankForm>

                                    <EditBankForm v-else-if="modalContent == 2 && editing == true"
                                        :bank="getSelectedBank" @closeModal="modalStatus"
                                        @changeModalContent="modalContent = $event">
                                    </EditBankForm>
                                </Modal>

                            </div>
                        </div>
                    </div>
                    <!-- /.card -->
                </div>
            </div>
            <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
</template>

<script>
import $ from 'jquery';
import { mapState, mapActions } from 'pinia';
import { useBanksStore } from '@/pinia/banks.module';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import Modal from '@/Components/Bootstrap/Modal.vue';
import AddBankForm from '@/Components/Forms/Banks/Add.vue';
import EditBankForm from '@/Components/Forms/Banks/Edit.vue';
import BanksTable from '@/Components/Tables/BanksTable.vue';
import Pagination from '@/Components/Bootstrap/Pagination.vue';

export default {
    components: {
        PrimaryButton,
        Modal,
        AddBankForm,
        EditBankForm,
        BanksTable,
        Pagination,
    },
    data() {
        return {
            currentPage: 1,
            itemsPerPage: 10,
            modalContent: 0,
            editing: false,
            searchString: '',
        };
    },
    computed: {
        ...mapState(useBanksStore, ['getBanks', 'getSelectedBank', 'filterBanksBySearchString']),
        filteredBanks() {
            return this.filterBanksBySearchString(this.searchString);
        },
    },
    methods: {
        ...mapActions(useBanksStore, ['fetchBanks', 'fetchBankById']),
        modalStatus(status) {
            if (status) {
                $('#modal-lg').modal('hide');
            }
        },
        setSelectedRecord(record) {
            this.fetchBankById(record.id);
        },
    },
    created() {
        this.fetchBanks();
    },
    mounted() { },
};
</script>
